import styled from "@emotion/styled";

const Tile = styled.div`
  position: relative;
  cursor: pointer;
  overflow: hidden;
`;

export default Tile;
